<template>
    <div class="l-row l-row--center">
        <div class="l-row__column l-row__column--7">
            <div class="l-row">
                <div class="l-row__column l-row__column--8">
                    <h1 class="a-title">Dziękujemy</h1>
                    <p class="a-text">
                        Dziękujemy, Twoja wiadomość została przesłana!
                    </p>
                    <br /><br />
                    <a-button @click="$router.push({ name: 'dashboard-offers' })">
                        Powrót do początku
                    </a-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: 'Dziękujemy!'
    }
}
</script>
